var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center fade-in"},[_c('content-header',{staticClass:"w-100 mxw-md px-10",attrs:{"title":"Dashboard","sub-title":_vm.subTitle}}),_c('member-board')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }